<template>
  <validation-provider
    :name="name"
    :rules="rules"
    v-slot="{ errors }"
    mode="passive"
    style="width: 100%"
    ref="providerInput"
  >
    <label class="__wrap" :class="checkClass(errors)">
      <input
        class="__input"
        :id="id"
        :placeholder="placeholder"
        :disabled="disabled"
        :type="type"
        v-model="valueInput"
        @blur="$emit('blur', $event)"
        @input="valueInput = checkType(valueInput)"
        @keydown="checkKey($event)"
        @keyup.enter="$emit('enter', $event)"
      />
      <span class="__unit" v-if="unit">{{ unit }}</span>
      <span class="btn-input" v-if="btn">
        <slot name="btn-input"></slot>
      </span>
    </label>

    <span id="error" v-if="validateInput != '' || errors[0]" class="is-invalid">
      {{ validateInput != "" ? validateInput : errors[0] }}
    </span>
  </validation-provider>
</template>

<script>
export default {
  props: {
    id: {
      value: String,
      default: "text",
    },
    type: {
      value: String,
      default: "text",
    },
    unit: {
      value: String,
      default: "",
    },
    btn: {
      value: Boolean,
      default: false
    },
    placeholder: {
      value: String,
      default: "",
    },
    disabled: {
      value: Boolean,
      default: false,
    },
    getVmodel: {
      value: String,
      default: "",
    },
    name: {
      value: String,
      default: "",
    },
    status: {
      value: [null, Boolean],
      default: null,
    },
    rules: {
      value: String,
      default: "",
    },
    validate: {
      value: String,
      default: '',
    },
  },

  model: {
    prop: "getVmodel",
    event: "value",
  },

  data() {
    return {
      valueInput: this.getVmodel,
      validateInput: this.validate,
      statusInput: this.status
    };
  },

  methods: {
    checkClass(error) {
      const result = this.disabled 
        ? '__disabled' 
        : ( this.statusInput == true ) 
          ? '__success'
          : ( this.statusInput == false || error[0] || this.validateInput != '' )
            ? '__error'
            : ''
      return result
    },

    checkKey($event) {
      if (
        ![
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "ArrowUp",
          "ArrowDown",
          "ArrowRight",
          "ArrowLeft",
          "Backspace",
          "Delete",
          "Enter",
          "Shift",
          "Tab",
        ].includes($event.key) &&
        ["number", "unit", "money","phone","onlyNumberkey"].includes(this.type)
      ) {
        $event.preventDefault();
      }
      else if (
        [
          " ",
          "Shift",
        ].includes($event.key) &&
        ["SKU_UPC"].includes(this.type)
      ) {
        $event.preventDefault();
      }
    },

    checkType(value) {
      let result = "";
      this.$emit("input", value)
      this.statusInput = null
      this.validateInput = ''
      this.$refs.providerInput.errors = [];
      switch (this.type) {
        case "number":
          result = this.formatNumber(value);
          break;
        case "onlyNumberkey":
          result = this.formatNumber(value);
          break;
        case "unit":
          result = this.formatUnit(value);
          break;
        case "money":
          result = this.formatUnit(value);
          break;
        case "serial":
          result = this.nonAccentVietnamese(value);
          break;
        case "SKU_UPC":
          result = (this.nonAccentVietnamese(value)).toUpperCase();
          break;
        case "notVietNamKey":
          result = this.nonAccentVietnamese(value);
          break;
        default:
          result = value;
          break;
      }

      return result;
    },

    formatNumber(val) {
      if (val.toString().slice(0, 1) == "0" && val.toString().length >= 2) {
        val = val.toString().slice(1, 2);
      }
      if (val === "") {
        val = 0;
      }
      return val;
    },

    formatUnit(val) {
      let output = "";
      let formatNumber = this.formatNumber(val);

      formatNumber = formatNumber.toString().split(".").join("");

      while (formatNumber.length >= 3) {
        const last3Digits = formatNumber.slice(
          formatNumber.length - 3,
          formatNumber.length
        );
        formatNumber = formatNumber.slice(0, formatNumber.length - 3);
        output = "." + last3Digits + output;
      }
      if (formatNumber.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = formatNumber + output;
      }
      return output;
    },

    nonAccentVietnamese(str) {
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "aa");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "ee");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "ii");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "oo");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "uu");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "yy");
      str = str.replace(/đ/g, "dd");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
      // str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
      return str;
    }
  },

  watch: {
    valueInput: {
      handler: function () {
        this.$emit("value", this.valueInput);
      },
    },

    getVmodel: {
      handler: function () {
        this.$refs.providerInput.errors = [];
        this.valueInput = this.getVmodel;
      },
    },

    validate: {
      handler: function () {
        this.validateInput = this.validate;
      },
    },

    status: {
      handler: function () {
        this.statusInput = this.status
        this.checkClass()
      },
    }
  },
};
</script>

<style scoped lang="scss">
.is-invalid {
  color: red;
  word-break: break-word;
  font-size: 13px
}

.__wrap {
  all: unset;
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #dddddd !important;
  padding: 12px 5px;
  cursor: text;

  .__input {
    flex: 1 1 100%;
    width: 0;
    padding: 0;

    background: #ffffff;

    position: relative;

    &::placeholder {
      color: #c7c9d1;
    }
  }

  &.__success {
    border: 1px solid #3DBB65 !important;
  }

  &.__error {
    border: 1px solid #DC2323 !important;
  }

  &.__disabled {
    color: #c7c9d1;
    background: #f2f3f4;

    cursor: default;

    input {
      color: #000;
      background: #f2f3f4;
    }
  }

  .__unit {
    flex: 0 0 auto;

    display: inline-flex;
    place-content: center;
    place-items: center;

    padding-left: 12px;
    margin-left: 8px;
    background-color: #fff;
    border-left: 1px solid #dddddd;
  }
}

.btn-input {
  display: inline-flex;
  width: 30px;
  font-weight: 600;
  cursor: pointer;
}

</style>
